import { Typography } from '@mui/material';
// import QuizIcon from '@mui/icons-material/Quiz';
import React, { FC } from 'react';

type ContentTitleWithIconProps = {
	content: string;
	icon: React.ElementType;
	iconFontSize?: string;
	id: string | undefined;
	className?: string;
};

const ContentTitleWithIcon: FC<ContentTitleWithIconProps> = ({
	content,
	icon,
	iconFontSize = 'medium',
	id,
	className,
}) => {
	const Icon = icon as React.ElementType;
	return (
		<Typography variant="h5" component="h5" id={id} className={className || ''}>
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					fontWeight: 600,
					letterSpacing: '0.5px',
				}}
			>
				<Icon
					color="secondary"
					style={{ marginRight: '5px' }}
					fontSize={iconFontSize}
				/>
				{content}
			</div>
		</Typography>
	);
};

export default ContentTitleWithIcon;
